import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faSkype } from "@fortawesome/free-brands-svg-icons"

export const Skype = (props) => {
  return <FontAwesomeIcon faIcon={faSkype} {...props} />
}
